// extracted by mini-css-extract-plugin
export default {"wrapper":"GlobalError_wrapper__Nv+dy"};